import { render, staticRenderFns } from "./VehicleProvisionDepartureReports.vue?vue&type=template&id=3872636d&scoped=true&"
import script from "./VehicleProvisionDepartureReports.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionDepartureReports.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionDepartureReports.vue?vue&type=style&index=0&id=3872636d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872636d",
  null
  
)

export default component.exports
import {QField,QTable,QTh,QTr,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QField,QTable,QTh,QTr,QTd,QBtn,QTooltip}, component.options.components || {})
